import React from 'react';
import { Route } from 'react-router-dom';
import Routes from './routes';
import DemandeLoginOublie from './demande';
import QuestionsLoginOublie from './questions';
import { getPath } from '../../../utils/router';

const RecupererLogin = () => {
    return (
        <>
            <Route
                path={getPath(Routes.subroutes.demande)}
                render={(subProps) => <DemandeLoginOublie {...subProps} />}
            />
            <Route
                path={getPath(Routes.subroutes.questions)}
                render={(subProps) => <QuestionsLoginOublie {...subProps} />}
            />
        </>
    );
};

export default RecupererLogin;
